import { Component, OnInit, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { Router } from '@angular/router'; // Import the Router
import { take, map } from 'rxjs/operators';

@Component({
  selector: 'app-password-reset-sent',
  templateUrl: './password-reset-sent.component.html',
  styleUrls: ['./password-reset-sent.component.scss']
})
export class PasswordResetSentComponent implements OnInit, OnDestroy {
  timerSubscription!: Subscription;
  minutes = 5;
  seconds = 0;

  constructor(private router: Router) {} // Inject the Router here

  ngOnInit(): void {
    const countdown = 300; // 5 minutes in seconds
    this.timerSubscription = interval(1000).pipe(
      take(countdown),
      map((x) => countdown - x - 1)
    ).subscribe(seconds => {
      this.minutes = Math.floor(seconds / 60);
      this.seconds = seconds % 60;
    }, () => {},
    () => {
      // Time's up
      this.router.navigate(['/']); // Automatically navigate when timer ends
    });
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}